export default __webpack_public_path__ + "static/bg-467c22a4bc89a55b6ba5a0c662a73df3.svg";